var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.695.038L6.978 4.726 2.26.038.81 1.481l6.167 6.142 6.166-6.142-1.45-1.443z",
    fill: "#036"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTQgOCIgZmlsbD0ibm9uZSI+CjxwYXRoIGQ9Ik0xMS42OTQ3IDAuMDM4MDg1OUw2Ljk3NzY0IDQuNzI2MDdMMi4yNjA1NiAwLjAzODA4NTlMMC44MTE1MjMgMS40ODEzM0w2Ljk3NzY0IDcuNjIyOEwxMy4xNDM4IDEuNDgxMzNMMTEuNjk0NyAwLjAzODA4NTlaIiBmaWxsPSIjMDAzMzY2Ii8+Cjwvc3ZnPg==";
export { SvgChevronDownV2 as ReactComponent };